export default function initVolunteerScript() {
  const volunteersContainer = document.querySelector(".volunteers-container");

  if (!volunteersContainer) return;

  new Swiper(volunteersContainer, {
    loop: true,
    spaceBetween: 16,
    grabCursor: true,
    autoHeight: true,

    autoplay: {
      delay: 3000,
    },

    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
      1280: {
        slidesPerView: 4,
      },
    },
  });
}

if (window.acf) {
  window.acf.addAction(
    "render_block_preview/type=volunteers",
    initVolunteerScript
  );
} else {
  document.addEventListener("DOMContentLoaded", function () {
    initVolunteerScript();
  });
}
